import {
  API_URL,
  REACT_APP_AWS_BUCKET_NAME,
} from "../../actions/settings";
import { UnexpectedError } from "../../pages/Errors/Errors";

async function getSignedUploadUrl(token:any,data:any) {

  return fetch(`${API_URL}/s3/upload_url`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':token
    },
    body: JSON.stringify(data),

  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      return {'error':error};
    });
 }
 
async function getSignedUrl(token:any,data:any) {

  return fetch(`${API_URL}/s3/get_file`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':token
    },
    body: JSON.stringify(data),

  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      return {'error':error};
    });
 }

 async function uploadToS3(url:any,file:any,contentType:any) {

  return fetch(`${url}`, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,      
    },
    body: file,

  })
    .then((res) => {
      if (res.status === 200) {
        return res;
      } else {
        console.log(res)
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      console.log(error)      
      console.log('Could not upload to s3 bucket')      
      return {'error':error};
    });
 }
 async function getFromS3(url:any,) {

  return fetch(`${url}`, {
    method: 'GET',
  })
    .then((res) => {
      if (res.status === 200) {
        return res.blob()
      } else {
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      console.log(error)      
      console.log('Could not Load file from s3 bucket')      
      return {'error':error};
    });
 }

 async function deleteFile(token:any,data:any) {

  return fetch(`${API_URL}/s3/delete`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':token
    },
    body: JSON.stringify(data),

  })
    .then((res) => {
      if (res.status === 200) {
        console.log(res)
        return res.json();
      } else {
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      return {'error':error};
    });
 }


const S3Bucket = {
  GetFile,
  UploadFile,
  UploadImage,
  Delete,
};

async function GetFile(filename: string,bucket_name: string|null){
//  Get File Pre Signed Url and load file
const data = {
      "bucket": bucket_name || REACT_APP_AWS_BUCKET_NAME || '',
      "filename": filename,
    };
  try {
    const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
    const url = await getSignedUrl(token,data)

    if ('presigned_url' in url){
      const res = await getFromS3(url['presigned_url'])

      if (res instanceof Blob){
        return res
      }
      else{
        return {
          status: "Failed",
          detail: String(res),
        }
      }      
    }
  }
  catch (error){
    return {
          status: "Failed",
          detail: String(error),
        };
  }
}


async function UploadImage(
  directory: string,
  id: string,
  image: any,
  filename: string,
  type?: string
) {
  // Upload and image/png to the s3Bucket
  const time = new Date();
  let full_filename = "none"
  if(type){
    full_filename = directory + "/" + id + '-' + type + '-img'
  }
  else{
    full_filename = directory + "/" + id + "/" + time.getTime() + "-" + filename
  }
  
  const data = {
      "bucket": REACT_APP_AWS_BUCKET_NAME || '',
      "filename": full_filename,
      "content_type": type || "image/png",
      // "ACL": "public-read",
    };

  try {
    const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
    const url = await getSignedUploadUrl(token,data)

    if ('presigned_url' in url){
      const res = await uploadToS3(url['presigned_url'],image,data['content_type'])
      if(res){
        return {
        status: "Success",
        detail: res,
      }}
      else{
        return {
          status: "Failed",
          detail: String(res),
        };
      }      
    }
  }
  catch (error){
    return {
          status: "Failed",
          detail: String(error),
        };
  }
}

async function UploadFile(
  bucket_name: string,
  filename: string,
  file: any,
  contentType: any
) {
  // Upload any File or item to S3 Bucket
  const data = {
      "bucket": bucket_name || '',
      "filename": filename,
      "content_type": contentType 
    };
  try {
    const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
    const url = await getSignedUploadUrl(token,data)
    if ('presigned_url' in url){
      const res = await uploadToS3(url['presigned_url'],file,data['content_type'])
      if(res){
        return {
        status: "Success",
        detail: res,
      }}
      else{
        return {
          status: "Failed",
          detail: String(res),
        };
      }      
    }
  }
  catch (error){
    return {
          status: "Failed",
          detail: String(error),
        };
  }
  
}

async function Delete(bucket_name: string, filename: string) {
  // Delete item form S3 Bucket
  const data = {
      "bucket": bucket_name || '',
      "filename": filename,
    };
  try {
    const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
    const res = await deleteFile(token,data)

    if('error' in res){
      console.log("There was an error deleting from S3 bucket ", res)
      return {
          status: "Failed",
          detail: String(res),
        };
    }
    else{
      
      console.log("Successfully Deleted object.", data);
      return {
        status: "Success",
        detail: data,
      };
    }
    
  }
  catch (error){
    return {
          status: "Failed",
          detail: String(error),
        };
  }
}

export default S3Bucket;
